// A video record exists from the moment the coach picks a file to upload, but its
// playable url is written only after AWS finishes transcoding, which can take
// minutes. Until then nothing that points at the video can play it, so every picker
// treats such a video as not ready. The url is the signal, rather than the upload
// drafts tree, because a draft is removed once processing ends and is never written
// for an upload that was abandoned or failed.
export const isVideoReady = (video) => Boolean(video?.video)
export const VIDEO_PROCESSING_LABEL = 'Processing'
export const VIDEO_PROCESSING_MESSAGE = 'This video is still processing. Wait until it is ready before using it.'

export function getVideoSize({ windowWidth, windowHeight, maxVidWidth, whRatio }) {
  const expectedWidth = windowWidth < maxVidWidth ? windowWidth : maxVidWidth
  const expectedHeight = expectedWidth / whRatio

  if (expectedHeight > windowHeight) {
    // video height becomes higher than window height,
    // start calculating video width based on screen height
    const adjustedHeight = windowHeight
    const adjustedWidth = adjustedHeight * whRatio
    return { videoWidth: adjustedWidth, videoHeight: adjustedHeight }
  } else {
    return { videoWidth: expectedWidth, videoHeight: expectedHeight }
  }
}
